import { fetchWithInterceptors, handleJSON, handleLegacyError, handleRetry, } from '@squareup/util-api-client';
import { isServer } from '@squareup/util-isomorphic';
export function getUserData() {
    if (isServer()) {
        throw new Error('getUserData cannot be called on the server');
    }
    if (!window.currentUserDataPromise) {
        window.currentUserDataPromise = fetchWithInterceptors('/dashboard/current-user-data', {
            method: 'GET',
            credentials: 'include',
            mode: 'no-cors',
        }, [(handleJSON), handleLegacyError, (handleRetry)]).catch((err) => {
            delete window.currentUserDataPromise;
            throw err;
        });
    }
    return window.currentUserDataPromise;
}
// Use to reset in tests (add to afterEach in your setup.ts)
export function resetUserData() {
    delete window.currentUserDataPromise;
}
